import { useState } from "react";
import { speakPhonemes, stopEspeak } from "../../speak/speakPhonemes";
import { compileRuleSet } from "../../rules/compileRuleSet";
import { lushootseedToIpa } from "../../ruleSets/lushootseed";
import { runRulesOnIpa } from "../../rules/runRules";
import { ColumnAlign } from "../widgets/ColumnAlign";
import { sampleText } from "../prime/inputOptions";
import { IpaKeyboard } from "../widgets/IpaKeyboard";
import { lushootSingles, lushootMulti, lushootLetterNames } from "./lushootseedKeys";
import { IpaButtons } from "../widgets/IpaButtons";

/** when an explicit width is needed for content */
const roughWidth = 360;

/** UI that converts Lushootseed to IPA & can then speak it */
export function ConvertLS() {
  const [rules] = compileRuleSet(lushootseedToIpa);
  const [inputText, setInputText] = useState(sampleText['Lushootseed']);
  const [outputText, setOutputText] = useState(runRulesOnIpa(sampleText['Lushootseed'], rules).ipa);
  const [insert, setInsert] = useState<[string] | undefined>();

  /** user changed the input text */
  function changeInputText(newText: string) {
    setInputText(newText);
    const results = runRulesOnIpa(newText, rules);
    setOutputText(results.ipa);
  }

  function speakOutput() {
    speakPhonemes(outputText, undefined, rules.addPhonemeLength);
  }

  return (<>
    <IpaButtons onClick={(s) => setInsert([s])} width={600}
      single={lushootSingles} multi={lushootMulti} descriptions={(s) => lushootLetterNames[s]} />
    <br />
    <IpaKeyboard cols={80} rows={5} value={inputText}
      single={lushootSingles} multi={lushootMulti}
      insert={insert} onChange={changeInputText} />
    <br />

    <ColumnAlign width={roughWidth}>{[
      <span key={1}></span>,
      <span key={2}>
        <button onClick={() => speakOutput()}>speak output</button>
        &nbsp;&nbsp;&nbsp;
        <button onClick={() => stopEspeak()}>stop</button>
      </span>,
    ]}</ColumnAlign>

    <textarea cols={80} rows={5} spellCheck={false} value={outputText}
      onChange={(event) => setOutputText(event.target.value)} />
  </>);
}
